import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "@/redux/ExportPage/fetchBaseQuery";

export const shipmentinvoiceApi = createApi({
  reducerPath: "shipmentinvoiceApi",
  baseQuery,
   tagTypes: ["ShipmentInvoive"],
  endpoints: (builder) => ({

    createShipmentInvoice: builder.mutation({
      query: ({ id, ...data }) => ({
        url: `/export/shipment/invoice/${id}`,
        method: "PUT",
        headers: { "X-Request-Id": Math.random().toString(36).substring(2) },
        body: {invoice:data}, 
      }),
      invalidatesTags: ["ShipmentInvoive"],
    }),
      // 🔹 Get all invoices by masterId
      getShipmentInvoiceById: builder.query({
        query: ({id}) => `/export/shipment/invoice/${id}`,
        transformResponse: (response) => response?.data?.[0] ?? [],
        providesTags: ["ShipmentInvoive"],
      }),
    
  }),
});

export const {
  useCreateShipmentInvoiceMutation,
  useLazyGetShipmentInvoiceByIdQuery,
} = shipmentinvoiceApi;
